import { Component, OnInit } from '@angular/core';
import { ClientService } from '@pulse-front/core';

interface Client {
  id: string;
  name: string;
  status: string;
  consumption: number | string;
}

@Component({
  selector: 'panel-b2b-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
})
export class ClientListComponent implements OnInit {

  clients: Client[] = [];
  searchTerm: string = '';
  loading: boolean = false;

  filteredClients: Client[] = [];

  constructor(private clientService: ClientService) { }

  ngOnInit(): void {
    this.getClients();
  }

  getClients(name: string = '') {
    this.loading = true;

    this.clientService.searchClients(name).subscribe({
      next: (response: any) => {
        const backendData = response.data || [];
        console.log(backendData,'backendData');

        // 1. Guardamos los datos en la variable maestra 'clients'
        this.clients = backendData.map((item: any) => ({
          id: item.id || item.code,
          name: item.name,
          status: item.enabled ? 'active' : 'inactive',
          consumption: item.consumption
        }));

        // 2. IMPORTANTE: Actualizamos TAMBIÉN la variable que usa la tabla
        // Si no hacemos esto, filteredClients sigue vacío y la tabla no muestra nada.
        this.filteredClients = this.clients;

        this.loading = false;
      },
      error: (err) => {
        console.error('Error cargando clientes:', err);
        this.loading = false;
      }
    });
  }

  onSearch(event: any): void {
    const term = event.target.value;
    this.searchTerm = term;
    this.getClients(term);
  }

  modalType: 'view' | 'edit' | 'delete' | 'create' | null = null;
  selectedClient: Client | null = null;
  editForm = { name: '', status: 'active' };

  openModal(type: 'view' | 'edit' | 'delete', client: Client) {
    this.modalType = type;
    this.selectedClient = client;
    if (type === 'edit') {
      this.editForm = { name: client.name, status: client.status };
    }
  }

  openCreateModal() {
    this.editForm = { name: '', status: 'active' };
    this.modalType = 'create';
    this.selectedClient = null;
  }

  closeModal() {
    this.modalType = null;
    this.selectedClient = null;
  }

  saveCreate() {
    this.clientService.createClient({ businessName: this.editForm.name }).subscribe({
      next: () => { this.closeModal(); this.getClients(); },
      error: (err: any) => console.error(err)
    });
  }

  saveEdit() {
    if (!this.selectedClient) return;
    this.clientService.updateClient(this.selectedClient.id, {
      businessName: this.editForm.name,
      status: this.editForm.status == 'active' ? 'Y' : 'N'
    }).subscribe({
      next: () => { this.closeModal(); this.getClients(); },
      error: (err: any) => console.error(err)
    });
  }

  confirmDelete() {
    if (!this.selectedClient) return;
    this.clientService.deleteClient(this.selectedClient.id).subscribe({
      next: () => { this.closeModal(); this.getClients(); },
      error: (err) => console.error('Error eliminando cliente:', err)
    });
  }
}